export * from './assets';
export * from './envs';
export * from './cookieYes';
export * as EVENTS from './events';

export const BRAND_NAME = 'Familonet';
export const TERMS_LINK = 'https://www.familo.net/terms.html';
export const POLICY_LINK = 'https://terms.familo.net/privacy-info';
export const COOKIE_POLICY_LINK = `${POLICY_LINK}/#cookie-policy`;
export const EBANX_BR_PAYMENT_TERMS_LINK =
  'https://www.ebanx.com/pt-br/legal/consumidores/brasil/termos-para-processar-pagamentos/';
export const APP_ONE_LINK = 'https://fml.onelink.me/3cUC/bnhyu1g7';
// export const APP_ONE_LINK = 'https://familo.onelink.me/AtGc/fduvb7ti';
export const SUPPORT_EMAIL = 'support@familo.net';
export const SITE = 'https://www.familo.net/';
// Keyed by the ids of link spans in translations (<span id='terms'>) and of link buttons
export const LINKS: Record<string, string> = {
  terms: TERMS_LINK,
  privacy: POLICY_LINK,
  cookie: COOKIE_POLICY_LINK,
  refund: `${TERMS_LINK}#refund-for-service-issues`,
  refund_policy: `${TERMS_LINK}#refund-policy`,
  subscription_policy: `${TERMS_LINK}#premium-subscription`,
  site: SITE,
  contact: `mailto:${SUPPORT_EMAIL}`,
  'support-email': `mailto:${SUPPORT_EMAIL}`,
};
export const SESSION_STORAGE_TOKEN_KEY = 'access_token';
export const COOKIE_UUID_KEY = 'userUuid';
export const FBC_PARAM = '_fbc';
export const FBP_PARAM = '_fbp';
export const TTP_PARAM = '_ttp';
export const AF_SMART_SCRIPT_KEY = 'AF_SMART_SCRIPT';
export const PAYMENT_GATEWAY_PROPERTY = 'Payment gateway';
export const PAYMENT_GATEWAY = {
  BRAINTREE: 'Braintree',
  stripe: (accountName?: string | null, fallback = '') => `Stripe [${accountName || fallback}]`,
} as const;
export const DEFAULT_DELAYED_TIME = 300;
export const GOOGLE_ADS_OB_START_ID = 'rOYNCPfBptIZEJqgyZQB';
export const GOOGLE_ADS_CONVERSION_ID = '0LxwCPrBptIZEJqgyZQB';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL = 'GMJ_CJfI9LkbEM_u-PlB';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_1 = 'yKq5CPqAuLgcELvUrOtD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_2 = 'MfjsCMSVuLgcEInUrOtD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_3 = 'yT0HCJyYt7gcEPGVretD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_4 = 'Nh1mCMrY2cscEOqR_oZE';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_5 = 'AyyUCKrz18scEKaB_oZE';
export const PL_VALUE_LANDING = 'pl_value';

export const PLTV_LANDINGS = [
  PL_VALUE_LANDING,
  'lp1ch2',
  'lp19',
  'lp17ch17pr3_h_fastpay2',
  'px',
  'lgpw',
  'up',
  'btstlk',
  'plv_lng_tst',
];

export const GOOGLE_ADS_REVIEW_ACCOUNT_ID = '2530921137-WEB-SF';
export const GOOGLE_ADS_ACCOUNT_ID = '9203700535-WEB-FO';
export const GOOGLE_ADS_PLTV_ACCOUNT_ID = '9203700535-WEB-FO-PLTV';

export const FROM_REVIEW_PARAM = 'from_review';
export const REVIEW_CLICK_ID_PARAM = 'review_click_id';
export const REVIEW_SOURCE_KEY = 'review_source';
export const REVIEW_CLICK_ID_KEY = 'review_click_id';
export const REVIEW_TS_KEY = 'review_ts';
export const REVIEW_COOKIE_DAYS = 30;
export const GOOGLE_ADS_REVIEW_CONVERSION_ID = 'wTf3CO37-fYbELnHke1C';
